<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { getDeviceState } from 'src/stores/device-runtime/states';
	//Design system components
	import { Text, CircleAvatar } from '@Shelly/shelly-design-system';
	//Helpers
	import { getDeviceAvatarDefaultConfig } from 'src/helpers/device_state_view_helpers';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
</script>

<CircleAvatar {...getDeviceAvatarDefaultConfig(device)} disabled />

<Text class="mb-s text-bold text-center">
	{$format(deviceState?.description?.value)}
</Text>
